import { render, staticRenderFns } from "./OrdersTableActions.vue?vue&type=template&id=f61dd3fc&"
import script from "./OrdersTableActions.vue?vue&type=script&lang=js&"
export * from "./OrdersTableActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports